/**
 * @ngdoc filters
 * @memberof mercury.filters
 * @name startof
 */
angular.module('mercury.filters.startof', [])
.filter('startof', function() {
  return function(time, period) {
    if (time === null) {
      return '';
    }
    return moment(time).mStartOf(period);
  };
});
